import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-model-fit-progress',
  templateUrl: './m-model-fit-progress.component.html',
  styleUrls: ['./m-model-fit-progress.component.scss'],
  imports: [NgClass]
})
export class MModelFitProgressComponent {
  @Input() topLabel = 'Top';
  @Input() bottomLabel = 'Bottom';
  @Input() topValue = 0;
  @Input() bottomValue = 0;
  @Input() showBottomValue = true;

  private readonly baseMax = 20;

  readonly axisLabels = [
    { value: 0, label: '0%' },
    { value: 10, label: '10%' },
    { value: 15, label: '15%' },
    { value: 20, label: '20%' }
  ];

  get topValuePosition(): number {
    return this.mapValueToPosition(this.topValue);
  }

  get bottomValuePosition(): number {
    return this.mapValueToPosition(this.bottomValue);
  }

  get topLabelClass(): string {
    return this.getLabelEdgeClass(this.topValuePosition);
  }

  get bottomLabelClass(): string {
    return this.getLabelEdgeClass(this.bottomValuePosition);
  }

  get thresholdPosition(): number {
    return this.mapValueToPosition(3);
  }

  get cutoffPosition(): number {
    return this.mapValueToPosition(20);
  }

  axisPosition(value: number): number {
    return this.mapValueToPosition(value);
  }

  formatPercent(value: number): string {
    return `${value.toFixed(2)}%`;
  }

  private getLabelEdgeClass(position: number): string {
    if (position <= 12) {
      return 'edge-left';
    }
    if (position >= 88) {
      return 'edge-right';
    }
    return '';
  }

  private mapValueToPosition(rawValue: number): number {
    const value = Number.isFinite(rawValue) ? Math.max(rawValue, 0) : 0;

    // map 0-10 to 0-25%.
    if (value <= 10) {
      return value * 2.5;
    }
    // map 10-15 to 25-50%.
    if (value <= 15) {
      return 25 + (value - 10) * 5;
    }
    // map 15-20 to 50-75%.
    if (value <= 20) {
      return 50 + (value - 15) * 5;
    }

    // map 20-25 to 75-100%.
    return Math.min(100, 75 + (value - this.baseMax) * 5);
  }
}
